<template>
  <div
      class="element-pre-container"
      :class="{ 'drag-over': isDragOver }"
      draggable="true"
      @dragstart="$emit('dragstart', $event)"
      @dragover.prevent="$emit('dragover', $event)"
      @drop.prevent="$emit('drop', $event)"
      @dragend="$emit('dragend')"
  >
    <div v-if="element.type === 'element'" class="element-container">
      <div class="element"><CustomTextField :content="element.text" /></div>
      <div class="durationQuantity"><CustomTextField :content="element.durationQuantity" /></div>
      <div class="unitPrice"><CustomTextField :content="element.unitPrice" /></div>
      <div class="discountedRate"><CustomTextField :content="element.discountedRate" /></div>
      <div class="tva"><CustomTextField :content="element.tva" /></div>
      <div class="amount">
        <p :class="{ 'text-deactivated': !isEditable }">{{ element.amount.value }}</p>
        <p class="currency" :class="{ 'text-deactivated': !isEditable }">€</p>
      </div>
      <div v-if="isEditable" class="minus-button-container">
        <button type="button" class="add-element button-icon" @click="$emit('remove')">
          <span class="fas fa-minus"></span>
        </button>
      </div>
    </div>

    <div v-if="element.type === 'title'" class="element-container">
      <div class="title"><CustomTextField :content="element.text" /></div>
      <div v-if="isEditable" class="minus-button-container">
        <button type="button" class="add-element button-icon" @click="$emit('remove')">
          <span class="fas fa-minus"></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CustomTextField from "@/components/forms/customs/customTextField/CustomTextField.vue";

export default {
  name: 'BusinessElementRow',
  components: { CustomTextField },
  props: {
    element: { type: Object, required: true },
    isEditable: { type: Boolean, default: false },
    isDragOver: { type: Boolean, default: false },
  },
  emits: ['remove', 'dragstart', 'dragover', 'drop', 'dragend'],
};
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

.element-container
  display flex
  gap 2px
  .title
    width 100%
    :deep(input.input)
      font-weight 600 !important
  .element
    width 100%
  .durationQuantity
    width 200px
  .unitPrice
    width 200px
  .discountedRate
    width 200px
  .tva
    width 150px
  .amount
    display flex
    align-items center
    justify-content space-between
    width 150px
    p
      font-size 0.9em
      margin 0
      &.text-deactivated
        color #717171
      &.currency
        padding-right 5px
  .minus-button-container
    display flex
    align-items center
    button
      width 20px
      height 20px
      margin-right 5px
      svg
        margin-left -4px

.element-container :deep(input.input)
  padding 0
  text-indent: 0;
  height 25px
  border 2px solid rgba(255, 255, 255, 0);
  font-weight 400 !important
  &:hover
    border 2px solid THEME_COLOR_PRIMARY;

.element-pre-container
  width 100%
  margin-bottom 2px

.element-pre-container.drag-over
  border-top 2px dashed #000
</style>